import GoalModal from "./GoalModal";
export default GoalModal;
